import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const TourSearch = () => {
  const navigate = useNavigate();

  const [keyword, setKeyword] = useState("");
  const [tourType, setTourType] = useState("Family");
  const [results, setResults] = useState([]);
  const [selectedItem, setSelectedItem] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  /* ===============================
     DEBOUNCED SEARCH
  =============================== */
  useEffect(() => {
    if (keyword.trim().length < 2) {
      setResults([]);
      return;
    }

    const timer = setTimeout(fetchResults, 400);
    return () => clearTimeout(timer);
  }, [keyword, tourType]);

  /* ===============================
     API CALL
  =============================== */
  const fetchResults = async () => {
    if (!keyword.trim()) return;

    setLoading(true);
    setError("");

    try {
      const formData = new FormData();
      formData.append("search_term", keyword.trim());
      formData.append("tour_type", tourType);

      const response = await fetch(
        "https://planjourneysglobal.com/admin/api/search_packages_destinations",
        {
          method: "POST",
          body: formData,
        }
      );

      const data = await response.json();

      if (data?.status && data?.data) {
        const packages = (data.data.packages || []).map((item) => ({
          ...item,
          _type: "package",
          displayName: item.title,
        }));

        const locations = (data.data.locations || []).map((item) => ({
          ...item,
          _type: "location",
          displayName: item.name,
        }));

        setResults([...packages, ...locations]);
      } else {
        setResults([]);
      }
    } catch (err) {
      setError("Server error. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  /* ===============================
     ITEM SELECT
  =============================== */
  const handleSelect = (item) => {
    setKeyword(item.displayName);
    setSelectedItem(item);
    setResults([]);

    // 🔁 ROUTING LOGIC
    if (item._type === "package") {
      navigate(`/tour-package/${item.slug}`);
    }

    if (item._type === "location") {
      navigate(`/destination/${item.slug}`);
      // 👉 change above URL if you have separate location page
      // navigate(`/destination/${item.slug}`);
    }
  };

  /* ===============================
     SUBMIT SEARCH
  =============================== */
  const handleSubmit = (e) => {
    e.preventDefault();

    if (selectedItem) {
      handleSelect(selectedItem);
      return;
    }

    if (results.length > 0) {
      handleSelect(results[0]);
      return;
    }

    setError("No package or location found");
  };

  return (
    <div style={{ position: "relative" }}>
      <form onSubmit={handleSubmit} className="filter-input tour show">
        <div className="single-search-box">
       
          <div className="custom-select-dropdown destination-dropdown">
            <div className="custom-select-search-area">
              <input
                type="text"
                placeholder="Search destination or package"
                value={keyword}
                onChange={(e) => {
                  setKeyword(e.target.value);
                  setSelectedItem(null);
                  setError("");
                }}
              />
            </div>

            {/* DROPDOWN */}
            {results.length > 0 && (
              <div
                style={{
                  position: "absolute",
                  width: "100%",
                  background: "#fff",
                  border: "1px solid #fff",
                  zIndex: 999,
                  left: 0,
                  borderRadius: "8px",
            
                }}
              >
                {results.map((item, index) => (
                  <div
                    key={`${item._type}-${item.id || index}`}
                    onClick={() => handleSelect(item)}
                    style={{
                      padding: "10px",
                      cursor: "pointer",
                      borderBottom: "1px solid #fff",
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    <span>{item.displayName}</span>

                    <small
                      style={{
                        background:
                          item._type === "location" ? "#f0f0f0" : "#ffe9c6",
                        padding: "2px 6px",
                        borderRadius: "4px",
                        fontSize: "11px",
                      }}
                    >
                      {item._type === "location" ? "Location" : "Package"}
                    </small>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>

        <button type="submit" className="primary-btn1">
          
          <span> <svg
                width={18}
                height={18}
                viewBox="0 0 18 18"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g>
                  <path d="M17.7799 16.746L14.6861 13.7226L14.6137 13.6126C14.4774 13.4781 14.2936 13.4028 14.1022 13.4028C13.9107 13.4028 13.7269 13.4781 13.5906 13.6126C10.9613 16.0246 6.91095 16.1554 4.12376 13.9188C1.33658 11.6821 0.680209 7.7696 2.58814 4.77921C4.49607 1.78882 8.37732 0.64519 11.6585 2.10734C14.9396 3.56949 16.5993 7.18566 15.539 10.555C15.5016 10.675 15.4972 10.8029 15.5262 10.9251C15.5552 11.0474 15.6166 11.1597 15.7039 11.2501C15.7921 11.3421 15.9027 11.4097 16.0248 11.4463C16.1469 11.4829 16.2764 11.4872 16.4007 11.4589C16.5243 11.4317 16.6387 11.3725 16.7323 11.2872C16.8258 11.202 16.8954 11.0936 16.934 10.973C18.1996 6.97472 16.2878 2.6716 12.434 0.848041C8.58017 -0.975514 3.94271 0.225775 1.52009 3.67706C-0.902526 7.12835 -0.382565 11.7918 2.74388 14.6518C5.87033 17.5118 10.6646 17.7083 14.0273 15.1173L16.7667 17.7955C16.9042 17.9276 17.0875 18.0014 17.2782 18.0014C17.4689 18.0014 17.6522 17.9276 17.7897 17.7955C17.8568 17.7298 17.9101 17.6513 17.9465 17.5648C17.9829 17.4782 18.0016 17.3852 18.0016 17.2913C18.0016 17.1974 17.9829 17.1045 17.9465 17.0179C17.9101 16.9313 17.8568 16.8529 17.7897 16.7872L17.7799 16.746Z" />
                </g>
              </svg>{loading ? "Searching..." : "SEARCH"}</span>
              <span> <svg
                width={18}
                height={18}
                viewBox="0 0 18 18"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g>
                  <path d="M17.7799 16.746L14.6861 13.7226L14.6137 13.6126C14.4774 13.4781 14.2936 13.4028 14.1022 13.4028C13.9107 13.4028 13.7269 13.4781 13.5906 13.6126C10.9613 16.0246 6.91095 16.1554 4.12376 13.9188C1.33658 11.6821 0.680209 7.7696 2.58814 4.77921C4.49607 1.78882 8.37732 0.64519 11.6585 2.10734C14.9396 3.56949 16.5993 7.18566 15.539 10.555C15.5016 10.675 15.4972 10.8029 15.5262 10.9251C15.5552 11.0474 15.6166 11.1597 15.7039 11.2501C15.7921 11.3421 15.9027 11.4097 16.0248 11.4463C16.1469 11.4829 16.2764 11.4872 16.4007 11.4589C16.5243 11.4317 16.6387 11.3725 16.7323 11.2872C16.8258 11.202 16.8954 11.0936 16.934 10.973C18.1996 6.97472 16.2878 2.6716 12.434 0.848041C8.58017 -0.975514 3.94271 0.225775 1.52009 3.67706C-0.902526 7.12835 -0.382565 11.7918 2.74388 14.6518C5.87033 17.5118 10.6646 17.7083 14.0273 15.1173L16.7667 17.7955C16.9042 17.9276 17.0875 18.0014 17.2782 18.0014C17.4689 18.0014 17.6522 17.9276 17.7897 17.7955C17.8568 17.7298 17.9101 17.6513 17.9465 17.5648C17.9829 17.4782 18.0016 17.3852 18.0016 17.2913C18.0016 17.1974 17.9829 17.1045 17.9465 17.0179C17.9101 16.9313 17.8568 16.8529 17.7897 16.7872L17.7799 16.746Z" />
                </g>
              </svg>{loading ? "Searching..." : "SEARCH"}</span>
        </button>
      </form>

      {error && (
        <p style={{ color: "red", marginTop: "6px" }}>{error}</p>
      )}
    </div>
  );
};

export default TourSearch;
